import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { KENDO_DROPDOWNLIST } from "@progress/kendo-angular-dropdowns";
import { KENDO_NUMERICTEXTBOX } from "@progress/kendo-angular-inputs";
import { OIL_CIRCUITS, OilArray } from "./oil-group";
import { ChangedFieldDirective } from "../../changed-field.directive";

@Component({
    selector: "app-oil-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, KENDO_NUMERICTEXTBOX, KENDO_DROPDOWNLIST],
    templateUrl: "./oil-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class OilTabComponent {
    readonly rows = input.required<OilArray>();
    /** The units the organization logs oil in. */
    readonly units = input.required<string[]>();

    readonly circuits = OIL_CIRCUITS;
}
